import { Fragment } from "react";
import poweredByEvvnt from "src/assets/images/powered_by_evvnt.png";
import ButtonLink from "src/components/atoms/ButtonLink";
import Image from "src/components/atoms/Image";
import CreateEventButton from "src/components/molecules/CreateEventButton";
import PortraitItem from "src/components/organisms/events/PortraitItem";
import SearchBar from "src/components/organisms/SearchBar/Widget";
import { useSelector } from "src/hooks/useSelector";
import Event from "src/models/Event";
import { createListWithAds } from "../../../utils/adHelper";
import { exists } from "../../../utils/objects";
import WidgetAd from "../../molecules/WidgetAd";

const WidgetPortrait = ({ rawEvents, adPosition, category }) => {
	const publisherSettings = useSelector((state) => state.publisherSettings);
	const events = rawEvents.map((event) => new Event(event, publisherSettings));
	const listWithAds = createListWithAds(
		events,
		exists(adPosition) ? [adPosition] : [],
	);

	const EventsGrid = ({ children }) => (
		<div className="grid gap-5 bg-white">{children}</div>
	);

	const EventsContainer = ({ children }) => (
		<div className="flex-1 relative z-1 bg-white rounded">{children}</div>
	);

	return (
		<main className="flex flex-col items-center text-gray-900 max-w-lg m-auto">
			<CreateEventButton extraClasses="w-full mb-2 normal-case font-bold text-sm" />
			<SearchBar category={category} />

			<div className="flex mt-0 w-full" id="main-container">
				<EventsContainer>
					<EventsGrid data-testid="widget-event-list">
						{listWithAds.map((listElement, index) => (
							<Fragment key={`event-list-item-${index}`}>
								{listElement.isAd && (
									<WidgetAd
										widgetType="vertical_widget"
										utmSource={publisherSettings.publisher.id}
										utmMedium="widget"
										utmCampaign="promote_asset"
									/>
								)}
								{!listElement.isAd && (
									<PortraitItem event={listElement.event} trackView={true} />
								)}
							</Fragment>
						))}
					</EventsGrid>
				</EventsContainer>
			</div>
			<div className="flex items-center justify-between mt-1 w-full">
				<ButtonLink
					text="More Events"
					href={publisherSettings.publisher.url}
					target="_top"
					extraClasses="shadow-none text-sm font-bold normal-case px-10"
				/>
				<a
					href="https://evvnt.com"
					target="_blank"
					className="block opacity-60 hover:opacity-100 transition-opacity"
					rel="noopener"
				>
					<Image
						src={poweredByEvvnt}
						alt="Powered by Evvnt"
						className="h-[18px] w-auto"
					/>
				</a>
			</div>
		</main>
	);
};

export default WidgetPortrait;
